import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { SettingsService } from "../../../../../../../services/settings.service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  TableConfiguration
} from "../../../../../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { ActionButton } from "../../../../../../../shared/components/paginated-data-table/action-button.model";
import { faThermometer2 } from "@fortawesome/free-solid-svg-icons/faThermometer2";
import {
  DELETE_DEVICE_MUTATION,
} from "../../../../../../../store/entities/warehouse-management/device/device.graphql";
import { BinAddComponent } from "./bin-add/bin-add.component";
import { NotificationService } from "../../../../../../../services/notification.service";
import { AppState } from "../../../../../../../store";
import { Store } from "@ngrx/store";
import { StoreItemActions } from "../../../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../../../store/entities/store-item/store-item.model";
import {
  DELETE_ZONES_BINS_MAPPING,
  GET_ALL_BIN,
  GET_ZONE_BIN_MAPPING
} from "../../../../../../../store/entities/warehouse-management/bin/bin.graphql";
import {
  WarehouseZone
} from "../../../../../../../store/entities/warehouse-management/building-zone/building-zone.model";
import { Bin } from "../../../../../../../store/entities/warehouse-management/bin/bin.model";
import { selectStoreItems } from "../../../../../../../store/entities/store-item/store-item.selectors";
import { Observable } from "rxjs";
export interface Bins {
  uniqueId: string,
  binNumber: string,
  isActive: boolean
}
@Component({
  selector: "app-bin-list",
  templateUrl: "./bin-list.component.html",
  styleUrl: "./bin-list.component.scss",
})
export class BinListComponent implements OnInit, OnDestroy {
  private settingService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);
  private notificationSettings: NotificationService =
    inject(NotificationService);

  constructor(private store: Store<AppState>, private active: ActivatedRoute) { }
  addPermission: string[] = ["can_create_bin"];
  bins$: Observable<Bins[]>
  pagination$: Observable<any>
  query;
  mutation;


  filters
  permissions = {
    edit: ["can_edit_bin"],
    delete: ["can_delete_bin"],
  };
  id
  async ngOnInit() {
    this.id = this.active.snapshot.params["uniqueId"]
    this.query = GET_ALL_BIN;
    this.filters = {
      pageNumber: 1,
      zoneUniqueId: this.active.snapshot.params["uniqueId"],
    };
    setTimeout(() => this.getBins(), 3000)

  }
  async fetchPage(pagination, action, evt = null) {
    switch (action) {
      case 'nextPage':
        this.store.dispatch(StoreItemActions.getStoreItems({ entity: StoreItemEntity.zoneBins, query: this.query, filtering: { ...this.filters, pageNumber: pagination.currentPageNumber + 1 }, fetchPolicy: 'network-only' }))
        this.bins$ = this.store.select(selectStoreItems(StoreItemEntity.zoneBins))
        break;
      case 'prevPage':
        this.store.dispatch(StoreItemActions.getStoreItems({ entity: StoreItemEntity.zoneBins, query: this.query, filtering: { ...this.filters, pageNumber: pagination.currentPageNumber - 1 }, fetchPolicy: 'network-only' }))
        this.bins$ = this.store.select(selectStoreItems(StoreItemEntity.zoneBins))
        break;
      default:
        this.store.dispatch(StoreItemActions.getStoreItems({ entity: StoreItemEntity.zoneBins, query: this.query, filtering: { ...this.filters, pageNumber: parseInt(evt.target.value, 10) }, fetchPolicy: 'network-only' }))
        this.bins$ = this.store.select(selectStoreItems(StoreItemEntity.zoneBins))
        console.log(parseInt(evt.target.value, 10));

    }
  }
  async fetchBins() {
    await this.store.dispatch(StoreItemActions.getStoreItems({ entity: StoreItemEntity.zoneBins, query: this.query, filtering: this.filters }))
  }
  async getBins() {
    await this.store.dispatch(StoreItemActions.getStoreItems({ entity: StoreItemEntity.zoneBins, query: this.query, filtering: this.filters }))
    this.bins$ = this.store.select(selectStoreItems(StoreItemEntity.zoneBins))
    this.pagination$ = this.store.select(selectStoreItems(StoreItemEntity.pagination))
    this.pagination$.subscribe(pagination => {
      if (pagination) {
        console.log('pagination', pagination);
      }
    })
  }

  onAdd(data = null, mode: 'upload' | 'create') {
    this.settingService.openDialogModal({
      component: BinAddComponent,
      data: {
        mode,
        ...data,
        uniqueId: data?.uniqueId,
        zoneUniqueId: this.active.snapshot.params["uniqueId"],
        binNumbers: data?.binNumbers
      },
    });
  };

  onDelete(evt) {
    this.notificationSettings
      .confirmation({ message: "Are you sure you wnat to delete?" })
      .then((result) => {
        if (result) {

          this.store.dispatch(
            StoreItemActions.removeStoreItem({
              entity: StoreItemEntity.zoneBinCoverage,
              id: evt?.id,
              input: { uniqueId: evt?.uniqueId },
              mutation: DELETE_ZONES_BINS_MAPPING,
            })
          );
        }
      });
  }
  protected readonly faThermometer2 = faThermometer2;
  ngOnDestroy(): void {

  }
}
